<template>
    <div class="acc_buy">
        <div class="full_loading" v-if="loading_pay">
            <van-loading type="spinner"/>
        </div>
        <div class="box goods">
            <div class="tit">商品信息</div>
            <div class="content">
                <div class="type" v-if="info">
                    交易类型：游戏角色&nbsp;|&nbsp;{{game_name}}
                </div>
                <div class="info" v-if="info">
                    <van-image class="icon" :src="game_icon" />
                    <div class="right">
                        <p class="p1" v-if="info.goods">
                            {{ info.goods.server_name }}
                            <!-- 1、安卓，2、IOS，3、通用服务器 -->
                            <i
                                v-if="info.goods_role_info&&info.goods_role_info.system_type">{{ info.goods_role_info.system_type == 1?'安卓':(info.goods_role_info.system_type == 2?'IOS':'通用服务器') }}</i>
                            <i v-if="info.goods&&info.goods.channel_name">渠道:{{info.goods.channel_name}}</i>
                        </p>
                        <p class="p2">
                            <span v-if="info.goods">{{ info.goods.role_name }}</span>
                            <img class="sex" src="../../assets/bx/acc/nan.png" alt=""
                                v-if="info.goods_role_info&&info.goods_role_info.sex == 1">
                            <img class="sex" src="../../assets/bx/acc/nv.png" alt=""
                                v-else-if="info.goods_role_info&&info.goods_role_info.sex == 2">
                            <span class="lv"
                                v-if="info.goods_role_info&&info.goods_role_info.lv">{{ info.goods_role_info.lv }}级</span>
                        </p>
                        <div class="p3">
                            <div class="left">
                                <span class="career"
                                    v-if="info.goods_role_info&&info.goods_role_info.career!=''">{{ info.goods_role_info.career }}</span>
                                <span class="power"
                                    v-if="info.goods_role_info&&info.goods_role_info.power">战力&nbsp;{{ info.goods_role_info.power }}</span>
                            </div>
                            <span class="price" v-if="info.goods"><i>&yen;&nbsp;</i>{{ info.goods.price }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="role-info" v-if="roleAttrConf.length > 0">
            <p class="ri-item" v-for="(item,i) in roleAttrConf" :key="i">
                <span>{{ item.name }}</span>
                <span>{{ item.val }}</span>
            </p>
        </div>

        <el-form ref="order" :show-message="showMessage" :model="actionData" @submit.native.prevent :rules="rules">
            <div class="box contact">
                <div class="tit">联系方式</div>
                <div class="content">
                    <el-form-item prop="phone">
                        <div class="item">
                            <div class="before">手机号码</div>
                            <div class="after phone">
                                <el-input placeholder="请输入手机号码" type="tel" v-model="actionData.phone" maxlength="11" @input="onInput" />
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="qq">
                        <div class="item">
                            <div class="before">Q&nbsp;Q号码</div>
                            <div class="after phone">
                                <el-input placeholder="请输入QQ号码" type="number" v-model="actionData.qq" maxlength="13" @input="onInput2" />
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </div>

            <div class="box contact" v-if="goods_type == 3">
                <div class="tit">担保验证</div>
                <div class="content">
                    <el-form-item prop="key">
                        <div class="item">
                            <div class="before">担保密钥</div>
                            <div class="after phone">
                                <el-input placeholder="请输入担保密钥" v-model="actionData.key" maxlength="20" />
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </div>

            <div class="box contact">
                <div class="tit">收货账号</div>
                <div class="content">
                    <!-- <div class="register_tips" v-if="child_user_id == ''">
                        <van-icon name="warning" color="var(--theme)" />
                        请填写未注册的账号或
                        <span @click="kefu">联系客服咨询</span>
                    </div>
                    <div class="register_tips" v-else>
                        <van-icon name="warning" color="var(--theme)" />
                        角色可转移至已有账号下新的小号或
                        <span @click="kefu">联系客服咨询</span>
                    </div> -->

                    <div class="item item-new mb">
                        <div class="before">角色转移至</div>
                        <div class="after">
                            <p :class="{'active': character_transfer == 1 || character_transfer == 2}" @click="changeType(1)" v-if="is_old_deliver == 1">现有账号</p>
                            <p :class="{'active': character_transfer == 3}" @click="changeType(3)">注册新账号</p>
                        </div>
                    </div>
                    <div class="item item-new mb" v-if="character_transfer != 3">
                        <div class="before">验证方式</div>
                        <div class="after">
                            <p :class="{'active': character_transfer == 1}" @click="changeType(1)">账号密码</p>
                            <p :class="{'active': character_transfer == 2}" @click="changeType(2)">手机验证码</p>
                        </div>
                    </div>
                    <div v-if="character_transfer == 1">
                        <el-form-item prop="game_account1">
                            <div class="item item-new">
                                <div class="before">游戏账号</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入游戏账号" v-model="actionData.game_account1" maxlength="20" @input="actionData.game_account1 = actionData.game_account1.replace(/[^0-9a-zA-Z]/g, '')" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="game_pwd1">
                            <div class="item item-new">
                                <div class="before">游戏密码</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入密码" v-model="actionData.game_pwd1" type="password"
                                    minlength="6" maxlength="20" @input="actionData.game_pwd1 = actionData.game_pwd1.replace(/\s+/g, '')" />
                                </div>
                            </div>
                        </el-form-item>
                        <!-- <el-form-item prop="game_pwd2">
                            <div class="item item-new">
                                <div class="before">确认密码</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入密码" v-model="actionData.game_pwd2" type="password"
                                    minlength="6" maxlength="20" @input="actionData.game_pwd2 = actionData.game_pwd2.replace(/\s+/g, '')" />
                                </div>
                            </div>
                        </el-form-item> -->
                    </div>

                    <div v-if="character_transfer == 2">
                        <el-form-item prop="mobile">
                            <div class="item item-new">
                                <div class="before">手机号</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入手机号码" type="tel" v-model="actionData.mobile" maxlength="11" @input="actionData.mobile = actionData.mobile.replace(/\D/g, '')" />
                                </div>
                            </div> 
                        </el-form-item>
                        <el-form-item prop="mobile_code">
                            <div class="item item-new">
                                <div class="before">验证码</div>
                                <div class="after phone">
                                    <el-input ref="mobile_code_input" placeholder="请输入验证码" type="tel" v-model="actionData.mobile_code" maxlength="6" @input="actionData.mobile_code = actionData.mobile_code.replace(/\D/g, '')" />
                                    <van-button ref="getcode_btn" class="getcode_btn" :class="{'van-button-disabled': !/^1[3-9]\d{9}$/.test(actionData.mobile) || countDown < 60}"
                                        :disabled="!/^1[3-9]\d{9}$/.test(actionData.mobile) || countDown < 60  || isSendingCode"
                                        @click="getMobileCode">{{ countDown != 60 ? countDown + 's' : '获取验证码' }}
                                    </van-button>
                                </div>
                            </div> 
                        </el-form-item>
                    </div>

                    <div v-if="character_transfer == 3">
                        <el-form-item prop="game_account">
                            <div class="item item-new">
                                <div class="before">游戏账号</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入游戏账号" v-model="actionData.game_account" maxlength="20" @input="actionData.game_account = actionData.game_account.replace(/[^0-9a-zA-Z]/g, '')" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="game_pwd">
                            <div class="item item-new">
                                <div class="before">设置密码</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入密码" v-model="actionData.game_pwd" type="password"
                                    minlength="6" maxlength="20" @input="actionData.game_pwd = actionData.game_pwd.replace(/\s+/g, '')" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item prop="game_repwd">
                            <div class="item item-new">
                                <div class="before">确认密码</div>
                                <div class="after phone">
                                    <el-input placeholder="请输入密码" v-model="actionData.game_repwd" type="password"
                                    minlength="6" maxlength="20" @input="actionData.game_repwd = actionData.game_repwd.replace(/\s+/g, '')" />
                                </div>
                            </div>
                        </el-form-item>
                        <div class="item item-new">
                            <div class="before">同步实名</div>
                            <div class="after">
                                <van-switch 
                                    v-model="is_sync" 
                                    active-color="#ee0a24" inactive-color="#dcdee0"
                                />
                                <div class="user_identify">
                                    {{ userData.realName }}&nbsp;
                                    {{ userData.idNumber }}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </el-form>
        <!-- <div class="account_left">
            <span class="before">账户余额</span>
            <p class="after">
                <span class="balance">
                    {{ eye?userData.balance:'******' }}
                    <van-icon color="#999" name="eye-o" v-if="eye" @click="changeEye" />
                    <van-icon color="#999" name="closed-eye" v-else @click="changeEye" />
                </span>
            </p>
        </div> -->
        <div class="check">
            <el-checkbox v-model="agree">
                我已知晓并同意
            </el-checkbox>
            <span @click="openAgree">《交易购买协议》</span>
        </div>
        <van-button class="publish_btn" round
            :disabled="!canSubmit"
            :loading="loading"
            @click="confirmOrder">确认下单
        </van-button>
    </div>
</template>

<script>
    import crypto from "crypto";
    import Fingerprint2 from 'fingerprintjs2'
    export default {
        data() {
            // 定义规则 (rule, value, callback) 
            const game_repwd = (rule, value, callback) => {
                if (value) {
                    if (this.actionData.game_pwd !== value) {
                        callback(new Error('两次输入的密码不一致'))
                    } else {
                        callback()
                    }
                } else {
                    callback(new Error('请再次输入密码'))
                }
            }
            const game_account = (rule, value, callback) => {
                const v = (value || '').toString().trim()
                if (!v) {
                    callback()
                    return
                }
                if (!/^[0-9a-zA-Z]+$/.test(v)) {
                    callback(new Error('注册账号仅支持字母/数字'))
                    return
                }
                if (v.length < 8 || v.length > 20) {
                    callback(new Error('注册账号长度需为8-20位'))
                    return
                }
                if (/^1[3-9]\d{9}$/.test(v)) {
                    callback(new Error('注册账号不能为手机号码'))
                    return
                }
                callback()
            }
            const game_account1 = (rule, value, callback) => {
                const v = (value || '').toString().trim()
                if (!v) {
                    callback()
                    return
                }
                if (!/^[0-9a-zA-Z]+$/.test(v)) {
                    callback(new Error('注册账号仅支持字母/数字'))
                    return
                }
                if (v.length < 6 || v.length > 20) {
                    callback(new Error('注册账号长度需为6-20位'))
                    return
                }
                if (/^1[3-9]\d{9}$/.test(v)) {
                    callback(new Error('注册账号不能为手机号码'))
                    return
                }
                callback()
            }
            return {
                rules: {
                    phone: this.$store.getters.rules.mobile,
                    mobile: [{
                        required: true,
                        message: '请输入手机号',
                        trigger: 'blur'
                    }],
                    mobile_code: [{
                        required: true,
                        message: '请输入验证码',
                        trigger: 'blur'
                    }],
                    key: [{
                        validator: (rule, value, callback) => {
                            if (this.goods_type == 3 && !(value || '').trim()) {
                                callback(new Error('请输入担保密钥'))
                                return
                            }
                            callback()
                        },
                        trigger: 'blur'
                    }],
                    qq: this.$store.getters.rules.qq,
                    game_account1: [{
                        required: true,
                        message: '游戏账号不能为空',
                    }, {
                        validator: game_account1,
                        trigger: 'blur'
                    }],
                    game_pwd1: [{
                            required: true,
                            message: '请输入密码',
                            trigger: 'blur'
                        },
                        {
                            min: 6,
                            max: 20,
                            message: '密码为6～20位',
                            trigger: 'blur'
                        }
                    ],
                    game_account: [{
                        required: true,
                        message: '游戏账号不能为空',
                    }, {
                        validator: game_account,
                        trigger: 'blur'
                    }],
                    game_pwd: [{
                            required: true,
                            message: '请输入密码',
                            trigger: 'blur'
                        },
                        {
                            min: 6,
                            max: 20,
                            message: '密码为6～20位',
                            trigger: 'blur'
                        }
                    ],
                    game_repwd: [{
                        required: true,
                        validator: game_repwd,
                        trigger: 'blur'
                    }]
                },
                eye: false,
                info: {

                },
                actionData: {
                    phone: '',
                    qq: '',
                    key: '',

                    pwd: '',
                    //混合支付
                    pay_type: '',
                    pay_amount: '',
                    // 1
                    game_account1: '',
                    game_pwd1: '',
                    game_pwd2: '',
                    //2
                    mobile: '',
                    mobile_code: '',
                    // 3
                    game_account: '',
                    game_pwd: '',
                    game_repwd: '',
                },
                is_sync: true, //是否同步实名  0：否  1：是

                agree: false,
                showMessage: true,

                game_name: '',
                game_icon: '',

                //特殊角色参数
                goods_type: null,
                price: '',
                countDown: 60,
                timer: null,
                isSendingCode: false,
                
                character_transfer: 1,//角色转移方式  1:现有账号、账号密码  2：现有账号、手机验证码  3：注册新账号
                loading: false,//确认下单loading
                loading_pay: false,

                app_id: null,
                account_id: null,
                server_id: null,
                server_name: null,
                role_id: null,
                role_name: '',
                is_old_deliver: 0,// 0不支持 1支持
                roleAttrConf: []
            }
        },
        computed: {
            goods_id() {
                return this.$route.query.goods_id
            },
            userData() {
                return this.$store.getters.state.userData || {};
            },
            isLogin() {
                return this.$store.getters.isLogin;
            },
            buyAgree() {
                return this.$store.state.buyAgree
            },
            access_token() {
                return this.$store.state.access_token
            },
            canSubmit() {
                if (!(this.actionData.phone && this.actionData.qq && this.agree)) {
                    return false;
                }
                if (this.goods_type == 3 && !(this.actionData.key || '').trim()) {
                    return false;
                }
                if (this.character_transfer == 1) {
                    return this.actionData.game_account1 && this.actionData.game_pwd1;
                } else if (this.character_transfer == 2) {
                    return this.actionData.mobile && this.actionData.mobile_code;
                } else if (this.character_transfer == 3) {
                    return this.actionData.game_account && this.actionData.game_pwd && this.actionData.game_repwd;
                }
                return false;
            }
        },
        created() {
            this.$store.dispatch("getUserData", true);
        },
        mounted() {
            if (this.buyAgree == 1) {
                this.agree = true
            }
            this.getDetail(this.goods_id)
        },
        beforeDestroy() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        methods: {
            changeType(type) {
                this.character_transfer = type;
                this.actionData.game_account1 = '';
                this.actionData.game_pwd1 = '';
                this.actionData.game_pwd2 = '';
                this.actionData.game_account = '';
                this.actionData.game_pwd = '';
                this.actionData.game_repwd = '';
                this.actionData.mobile = '';
                this.actionData.mobile_code = '';
               

                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.countDown = 60;
                this.$nextTick(() => {
                    this.$refs.order.clearValidate();
                    this.is_sync = true; //是否同步实名  0：否  1：是
                });
            },
            onInput(val) {
                this.actionData.phone = val.replace(/\D/g, '');
            },
            onInput2(val) {
                this.actionData.qq = val.replace(/\D/g, '');
            },
            //获取手机验证码
            getMobileCode() {
                this.isSendingCode = true;
                this.$Ajax('common/send-code', {
                    app_id: this.app_id,
                    mobile: this.actionData.mobile,
                    action: 'bind'
                }).then(rs => {
                    if (rs.code == 200) {
                        this.$toast('发送成功');
                        this.countDown = 59
                        this.timer = setInterval(() => {
                            this.countDown--;
                            if (this.countDown <= 0) {
                                clearInterval(this.timer);
                                this.countDown = 60;
                                this.timer = null;
                                this.isSendingCode = false
                            }
                        }, 1000);
                    } else {
                        this.$toast(rs.msg || '发送失败');
                    }
                }).catch(() => {
                    this.countDown = 60;
                    this.isSendingCode = false;
                    this.$toast('发送失败，请重试');
                })
            },
            getDetail(goods_id) {
                this.$Ajax('goods-role/detail', {
                    goods_id
                }, 'post').then(rs => {
                    if (rs.code == 200) {
                        this.info = rs.data
                        this.game_name = rs.data.app_name
                        this.game_icon = rs.data.icon
                        this.goods_type = rs.data.goods.goods_type
                        this.price = rs.data.goods.price
                        this.child_user_id = rs.data.goods_role_info.child_user_id

                        this.app_id = rs.data.goods.app_id
                        this.account_id = rs.data.goods.account_id
                        this.server_id = rs.data.goods.server_id
                        this.server_name = rs.data.goods.server_name
                        this.role_id = rs.data.goods.role_id
                        this.role_name = rs.data.goods.role_name

                        if(rs.data.goods.app_id) {
                            this.$Ajax('game/app-list').then(res => {
                                if (res.code == 200) {
                                    var item = res.data.find(item => item.id == rs.data.goods.app_id)
                                    this.is_old_deliver = item.is_old_deliver
                                    if(this.is_old_deliver == 0) {
                                        this.character_transfer = 3
                                    }
                                }
                            })
                        }
                        if(rs.data.roleAttrConf) {
                            if(Array.isArray(rs.data.roleAttrConf)) {
                                this.roleAttrConf = rs.data.roleAttrConf
                            }else {
                                this.roleAttrConf = Object.values(rs.data.roleAttrConf)
                            }
                        }
                    }
                })
            },
            //联系客服
            kefu() {
                window.location.href =
                    'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_' +
                    this.userData.user_id + '&phone=' + this.userData.username
            },
            //agree
            openAgree() {
                var that = this
                this.$filterPop({
                    type: 'agree2',
                    direction: 'fade',
                    onSuccess: () => {
                        that.agree = true
                    }
                })
            },
            changeEye() {
                var that = this
                if (this.isLogin) {
                    that.eye = !that.eye
                } else {
                    this.$filterPop({
                        type: 'login',
                        direction: 'up',
                        onSuccess: () => {
                            that.eye = !that.eye
                        }
                    })
                }
            },
            //余额不足 前往充值
            // gotoRecharge() {
            //     this.$router.push({
            //         name: 'user.recharge',
            //         query: {
            //             from: 'accbuy'
            //         }
            //     })
            // },
            //确认下单按钮
            confirmOrder() {
                var that = this
                that.$refs.order.validate(valid => {
                    that.showMessage = true;
                    if (valid) {
                        this.loading = true
                        var params = {
                            goods_id: this.goods_id,
                            phone: this.actionData.phone,
                            qq: this.actionData.qq,
                        }
                        if (this.goods_type == 3) {
                            params.key = this.actionData.key
                        }
                        if(this.character_transfer == 1) {
                            params.transfer_type = 1
                            params.check_type = 1
                            params.account = this.actionData.game_account1
                            params.password = this.actionData.game_pwd1
                        }else if(this.character_transfer == 2) {
                            params.transfer_type = 1
                            params.check_type = 2
                            params.mobile = this.actionData.mobile
                            params.code = this.actionData.mobile_code
                        }else if(this.character_transfer == 3) {
                            params.transfer_type = 2
                            params.account = this.actionData.game_account
                            params.password = this.actionData.game_pwd
                            params.repassword = this.actionData.game_repwd
                            params.is_sync_idno = this.is_sync ? 1 : 0
                        }
                        this.$Ajax('v2/order/role',params).then(res => {
                            if(res.code == 200) {
                                this.$Ajax('pay-password/isset', {}, 'get').then(rs => {
                                    if (rs.code == 200) {
                                        if (rs.data.isset) {
                                            this.$filterPop({
                                                type: 'mixpay',
                                                direction: 'up',
                                                selection: {
                                                    price: this.price,
                                                    balance: this.userData.balance
                                                },
                                                onSuccess: (e) => {
                                                    this.actionData.pay_type = e.pay_type
                                                    this.actionData.pay_amount = e.pay_amount
                                                    if(e.pay_type == 2) {
                                                        this.buy(res.data.order_num)
                                                        return
                                                    }
                                                    this.$filterPop({
                                                        type: 'password',
                                                        direction: 'up',
                                                        onFunc: (a) => {
                                                            this.actionData.pwd = a.password
                                                            this.buy(res.data.order_num)
                                                        }
                                                    })
                                                }
                                            })
                                        } else {
                                            this.$RModal.tip({
                                                selection: {
                                                    title: '尚未设置支付密码，请先前往设置',
                                                    btn: '前往设置'
                                                },
                                                onSuccess: () => {
                                                    this.$router.push({
                                                        name: 'user.password'
                                                    })
                                                }
                                            })
                                        }
                                    }
                                })
                            }
                        }).finally(() => {
                            setTimeout(() => {
                                this.loading = false
                            }, 2000);
                        })
                    } else {
                        that.$toast('填写错误，请检查')
                    }
                })

            },
            buy(order_num) {
                var that = this
                this.loading_pay = true
                var params = {
                    order_num,
                    goods_id: this.goods_id,
                    pay_type: this.actionData.pay_type,
                    pay_amount: this.actionData.pay_amount
                }
                if(this.actionData.pwd) {
                    params.password = this.actionData.pwd
                }
                this.$Ajax('v2/order/role-pay', params).then(rs => {
                    if (rs.code == 200) {
                        this.$store.commit('changeBuyAgree', 1)
                        if (this.actionData.pay_type == 1) {
                            setTimeout(() => {
                                this.loading_pay = false
                            }, 1000);
                            this.$router.push({
                                name: 'order.status',
                                query: {
                                    order_num: rs.data.order_num
                                }
                            })
                            return
                        }
                        this.$Ajax('pay/pay', {
                            orderNum: rs.data.balance_order_num,
                            payType: 'alipay',
                            scene: 'wap',
                            type: 'balance'
                        }).then(res => {
                            setTimeout(() => {
                                this.loading_pay = false
                            }, 1000);
                            if (res.code == 200) {
                                if (res.data.type == 'redirect') {
                                    var timestamp = Date.parse(new Date()) / 1000
                                    var uuids = this.uuid();
                                    const request_id = this.MD5(that.access_token + uuids + timestamp);
                                    var udid = this.udid
                                    var sign = this.sign({
                                        orderNum: rs.data.balance_order_num,
                                        payType: 'alipay',
                                        scene: 'wap',
                                        type: 'balance',
                                        udid,
                                        request_id,
                                        timestamp,
                                    })
                                    window.location.href = this.$BaseURL + res.data.url + '&udid=' + udid + '&request_id=' + request_id + '&timestamp=' + timestamp + '&sign=' + sign
                                }
                            }
                        }).catch(() => {
                            setTimeout(() => {
                                this.loading_pay = false
                            }, 1000);
                        })
                    } else {
                        setTimeout(() => {
                            this.loading_pay = false
                        }, 1000);
                        this.actionData.pwd = ''
                    }
                }).catch(() => {
                    this.loading_pay = false
                })
            },
            async getUdid() {
                var that = this
                const fp = await new Promise((resolve) => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component, index) => {
                            if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不     一样
                                return component.value.replace(/\bNetType\/\w+\b/, '')
                            }
                            return component.value
                        })
                        // 生成最终id murmur 
                        // console.log(values,'使用的浏览器信息')  //使用的浏览器信息
                        const udid = Fingerprint2.x64hash128(values.join(''), 31)
                        // console.log(udid,'生成的标识码') //生成的标识码
                        that.udid = udid
                        resolve(udid);
                    })
                })
                return fp;
            },
            uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8,
                    1); // bits 6-7 of the      clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            },
            MD5(value) {
                return crypto.createHash("md5").update(value).digest("hex");
            },
            sign(params = {}) {
                const keys = Object.keys(params).sort();
                const signs = [];
                for (let key of keys) {
                    if (params[key] == null) continue;
                    signs.push(key + '=' + params[key]);
                }
                return this.MD5(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
            },
        },
        watch: {

        },
    }
</script>

<style lang="less" scoped>
    .full_loading {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999999999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .info {
        display: flex;
        margin-bottom: 1rem;

        .icon {
            width: 6rem;
            height: 6rem;
            border-radius: 1rem;
            overflow: hidden;
            margin-right: .9rem;
        }

        .right {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .p1 {
                font-size: 1.3rem;
                color: #999;

                i {
                    border-left: 1px solid #999;
                    margin-left: 0.4rem;
                    padding-left: 0.6rem;
                }
            }

            .p2 {
                font-size: 1.3rem;
                columns: #999;
                display: flex;
                align-items: center;

                .sex {
                    width: 1.6rem;
                    height: 1.6rem;
                }

                span {
                    color: #000;
                }

                .lv {
                    color: #999;
                    border-left: 1px solid #999;
                    margin-left: 0.4rem;
                    padding-left: 0.6rem;
                }
            }

            .p3 {
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 1.3rem;
                color: #999;

                .left {
                    .career {
                        color: #000;
                        padding-right: 1rem;
                    }

                    .power {
                        border-left: 1px solid #999;
                        padding-left: 0.6rem;
                    }
                }

                .price {
                    font-size: 1.6rem;
                    color: var(--theme);
                    font-weight: 700;

                    i {
                        font-size: 1.2rem;
                        font-weight: 400;
                    }
                }
            }
        }
    }

    .acc_buy {
        padding: 1.6rem 1rem;
    }

    .box {
        border-radius: 1rem;
        margin-bottom: .8rem;
        background-color: #fff;
        overflow: hidden;

        .tit {
            background: var(--theme);
            color: #fff;
            padding: 1rem;
            font-size: 1.6rem;
            font-weight: 700;
        }

        .content {
            padding: 1.5rem 1rem 1rem;

            .el-form-item {
                margin-bottom: 1.8rem;

                /deep/.el-form-item__error {
                    right: 0;
                    text-align: end;
                    margin-top: 0;
                    font-size: 1.2rem;
                }
            }
        }
    }

    .goods {
        .content {
            padding-top: .8rem;

            .type {
                font-size: 1.6rem;
                color: #000;
                word-break: break-all;
                margin-bottom: .9rem;
            }
        }
    }


    .contact {
        .item {
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;

            .before {
                width: 6.6rem;
                margin-right: 1.5rem;
                font-size: 1.6rem;
                color: #000;
            }

            .after {
                flex: 1;
            }

            .goods_name {
                /deep/.el-input {

                    .el-input__inner {
                        border: none;
                        height: 4rem;
                        line-height: 4rem;
                        background-color: #f5f5f5;
                        border-radius: 1rem;
                        padding: 0;
                        padding: 0 5rem 0 1.6rem;
                        font-size: 1.4rem;
                    }

                    .el-input__suffix {
                        .el-input__suffix-inner {
                            .el-input__count {
                                .el-input__count-inner {
                                    text-align: end;
                                    width: 4rem;
                                    font-size: 1.4rem;
                                    color: #999;
                                    margin: 0;
                                    background-color: transparent;
                                }
                            }
                        }

                    }
                }
            }

            .exprice_day,
            .phone {
                display: flex;
                align-items: center;
                /deep/.el-input {
                    flex: 1;
                    .el-input__inner {
                        border: none;
                        height: 4rem;
                        line-height: 4rem;
                        background-color: #f5f5f5;
                        border-radius: 1rem;
                        padding: 0;
                        padding: 0 1.6rem;
                        font-size: 1.4rem;
                    }
                }
                .getcode_btn {
                    height: 4rem;
                    width: 10.6rem;
                    font-size: 1.3rem;
                    margin-left: .9rem;
                    border-radius: 1rem;
                    background-color: #FFEFE4;
                    color: #F66F30;
                    border: none;
                    &:active {
                        opacity: 1;
                        transition: unset;
                    }
                    &:disabled {
                        background-color: #999;
                        color: #fff;
                        opacity: 1;
                        cursor: not-allowed;
                        transition: unset;
                    }
                }
            }

            .price {
                display: flex;
                align-items: center;

                /deep/.el-input {
                    .el-input__inner {
                        border: none;
                        height: 4rem;
                        line-height: 4rem;
                        background-color: #f5f5f5;
                        border-radius: 1rem;
                        padding: 0;
                        padding: 0 1.6rem;
                        font-size: 1.4rem;
                    }
                }

                span {
                    font-size: 1.6rem;
                    color: #000;
                    margin-left: 1rem;
                }
            }

            &.item-new {
                &.mb {
                    margin-bottom: 1.8rem;
                }
                .before {
                    width: 8rem;
                    text-align: justify;
                    text-align-last: justify;
                }
                .after {
                    display: flex;
                    align-items: center;
                    p {
                        width: 50%;
                        height: 4rem;
                        line-height: 4rem;
                        text-align: center;
                        border-radius: 1rem;
                        cursor: pointer;
                        background-color: #f5f5f5;
                        font-size: 1.4rem;
                        color: #555;
                        &:not(:last-child) {
                            margin-right: 1.4rem;
                        }
                        &.active {
                            background-color: #FFEFE4;
                            color: #F66F30;
                        }
                    }
                }
                /deep/ .van-switch {
                    width: 3.8rem;
                    height: 2rem;
                    .van-switch__node {
                        width: 1.6rem;
                        height: 1.6rem;
                        top: .2rem;
                        left: .2rem;
                    }
                    &.van-switch--on {
                        .van-switch__node {
                            transform: translateX(1.9rem);
                        }
                    }
                }
                .user_identify {
                    width: 19.8rem;
                    height: 4rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.4rem;
                    background-color: #F5F5F5;
                    border-radius: 1rem;
                    margin-left: .5rem;
                }
            }
        }

        .slider {
            display: flex;
            justify-content: space-between;
            align-items: center;

            p {
                width: 2.6rem;
                font-size: 1.6rem;
            }

            .max {
                text-align: end;
            }

            .van-slider {
                flex: 1;
            }

            /deep/.van-slider__button {
                background-color: var(--theme);
                cursor: pointer;
                box-shadow: none;
                animation: btnscale 1s ease-in-out 2 forwards;
            }
        }

        .margin {
            margin-top: 3rem;
            display: block;

            .line1 {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 1.4rem;

                p {
                    display: flex;
                    align-items: center;
                    font-size: 1.6rem;
                    color: #000;

                    .van-icon {
                        font-size: 1.4rem;
                        margin-left: 0.5rem;
                        margin-top: 0.2rem;
                        font-weight: 700;
                        cursor: pointer;
                    }
                }

                a {
                    color: var(--theme);
                    font-size: 1.6rem;
                    text-decoration: underline;
                }
            }

            .line2 {
                display: flex;
                height: 8.5rem;
                background-color: #f5f5f5;
                border-radius: 1rem;

                .left,
                .right {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: relative;
                    font-size: 1.4rem;

                    p:nth-child(1) {
                        margin-bottom: .6rem;
                    }

                    p:nth-child(2) {
                        font-weight: 700;
                    }

                    &::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 1px;
                        height: 1.8rem;
                        background-color: #000;
                    }
                }

                .right {
                    &::after {
                        display: none;
                    }
                }
            }
        }
    }

    .contact {
        .el-form-item {
            margin-bottom: 2rem;
        }
    }

    .account_left {
        background-color: #fff;
        padding: 1.2rem 1rem;
        border-radius: 1rem;
        display: flex;
        margin-bottom: .8rem;

        .before {
            width: 6.6rem;
            font-size: 1.6rem;
            color: #000;
            margin-right: 1.5rem;
        }

        .after {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .balance {
                font-size: 1.6rem;
                color: #999;

                .van-icon {
                    cursor: pointer;
                    font-size: 1.8rem;
                    margin-left: 0.4rem;
                }
            }

            .goto_balance {
                font-size: 1.6rem;
                color: var(--theme);
            }
        }
    }

    .check {
        display: flex;
        align-items: center;

        /deep/.el-checkbox__inner {
            width: 1.5rem !important;
            height: 1.5rem !important;

            &::after {
                height: 0.75rem !important;
                left: 0.35rem !important;
                top: 0 !important;
            }
        }

        /deep/.el-checkbox {
            width: unset !important;

            .el-checkbox__input {
                display: flex;
                align-items: center;
            }

            .el-checkbox__label {
                margin-top: 0.25rem;
                width: auto;
                font-size: 1.2rem;
                color: #aaa;
                transform: scale(1);
            }
        }

        span {
            font-size: 1.2rem;
            color: var(--theme);
            cursor: pointer;
        }
    }

    .publish_btn {
        width: 100%;
        height: 4rem;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        background-color: var(--theme);
        margin: 1.8rem 0 3rem;
        font-size: 1.6rem;

        &:disabled {
            background-color: #999;
            opacity: 1;
        }
    }

    .bottom_pop {
        height: 30rem;
        background-color: #f2f2f2;
        border-top-left-radius: 0.6rem;
        border-top-right-radius: 0.6rem;

        .close_btn {
            position: absolute;
            top: 1rem;
            right: 1rem;
            width: 1.8rem;
            height: 1.8rem;

            &::before,
            &::after {
                content: "";
                position: absolute;
                top: 50%;
                left: 50%;
                width: 0.2rem;
                height: 2.4rem;
                background-color: var(--fade5);
            }

            &::before {
                transform: translate(-50%, -50%) rotate(45deg);
            }

            &::after {
                transform: translate(-50%, -50%) rotate(-45deg);
            }
        }

        .title {
            padding: 1rem 1.2rem;
            font-size: 1.6rem;
            margin-bottom: 2rem;
        }

        .pay_area {
            /deep/.el-form-item__content {
                height: 4rem;
                position: relative;
                padding: 0 !important;

                .pt {
                    position: absolute;
                    left: 1.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.4rem;
                }

                .error {
                    color: var(--red);
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                    font-size: 1.2rem;
                }

                .pay_type {
                    position: absolute;
                    right: 1.2rem;
                    top: 50%;
                    transform: translateY(-50%);
                    font-size: 1.4rem;
                }
            }
        }

        .box {
            margin: 0 1rem;

            .el-form-item {
                margin-bottom: 0;
                border-bottom: 1px solid #eee;

                i {
                    color: var(--warning);
                }
            }

            /deep/.el-form-item__content {
                display: flex;
                align-items: center;
                background-color: #fff;
                border-radius: 0.3rem;
                padding-left: 1.2rem;
                font-size: 1.4rem;

                .label {
                    width: 5rem;
                    font-size: 1.3rem;
                }

                .el-input {
                    flex: 1;
                    border: none;
                    outline: none;

                    input {
                        border: none;
                        outline: none;
                        text-align: start;
                        padding: 0;
                        font-size: 1.3rem;
                    }
                }

                .el-form-item__error {
                    left: 1rem;
                    right: unset;
                    z-index: 10;
                    top: 100%;
                }
            }
        }
    }

    .pwd_area {
        /deep/.van-loading {
            i {
                color: #aaa !important;

            }
        }
    }

    .pwd_area2 {
        padding-top: 0;

        /deep/.el-form-item__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
        }

        .ing {
            height: 2rem;
            font-size: 1rem;
            margin-top: -1rem;
        }
    }

    .register_tips {
        display: flex;
        align-items: center;
        font-size: 1.4rem;
        color: #999;
        margin-bottom: 1rem;

        .van-icon {
            font-size: 1.6rem;
            margin-right: .5rem;
        }

        span {
            color: #0752FF;
            text-decoration: underline;
            cursor: pointer;
        }
    }

    .role-info {
        background-color: rgba(255, 240, 233, .46);
        border-radius: 1rem;
        padding: 1.7rem 1rem;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        margin-bottom: .8rem;
        &::after {
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 1px;
            height: calc(100% - 3.4rem);
            background-color: rgba(146, 146, 146, .3);
        }
        .ri-item {
            width: 50%;
            font-size: 1.3rem;
            color: #000;
            margin-top: 1.4rem;
            display: flex;
            justify-content: space-between;
            &:nth-of-type(1),
            &:nth-of-type(2) {
                margin-top: 0;
            }
            &:nth-of-type(2n) {
                padding-left: 2rem;
            }
            &:nth-of-type(2n+1) {
                padding-right: 2rem;
            }
        }
    }
</style>
